import { render, staticRenderFns } from "./StockInOuRecord.vue?vue&type=template&id=221ab978"
import script from "./StockInOuRecord.vue?vue&type=script&lang=js"
export * from "./StockInOuRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports